export default __webpack_public_path__ + "static/media/premierepro.9211e4a7.svg";